export default __webpack_public_path__ + "static/media/alert-tooltip-green.190d8a19.svg";